import dom from '../../lib/dom.js';
import preconditions from '../../lib/preconditions.js';

const checkPreconditions = preconditions('filterLoadIndicator', {
    progressElements: 'list',
    eventHub: 'object',
});

export default function setupFilterLoadIndicator(params) {
    checkPreconditions(params);

    dom.addClass('hidden', params.progressElements);

    params.eventHub.subscribe('resultViewCriteria:changed', () => {
        dom.removeClass('hidden', params.progressElements);
    });

    params.eventHub.subscribe('result-rendered', () => {
        dom.addClass('hidden', params.progressElements);
    });

    params.eventHub.subscribe('polling-complete', () => {
        dom.addClass('hidden', params.progressElements);
    });
}
